import { useQuery } from '@tanstack/react-query';

import { useGetAllPropertyManagers } from '@/api/endpoints/propertyManager/useGetAllPropertyManagers';
import { PropertyManagementRole } from '@/api/enums';
import { useAuth } from '@/context/AuthProvider';
import { usePropertyManager } from '@/context/PropertyManagerProvider';

/**
 * Hook to check if the current user has admin role for the selected property location
 */
export const useCurrentUserAdmin = () => {
  const { user } = useAuth();
  const { selectedPropertyLocation } = usePropertyManager();

  const getAllPropertyManagersQuery = useGetAllPropertyManagers(
    { location_id: selectedPropertyLocation?.id },
    !!selectedPropertyLocation?.id && !!user?.id
  );

  return useQuery({
    queryKey: ['current-user-admin', selectedPropertyLocation?.id, user?.id],
    queryFn: () => {
      if (!getAllPropertyManagersQuery.data || !user?.id) {
        return false;
      }

      // Find the current user in the property managers list
      const currentUserManagement = getAllPropertyManagersQuery.data.find(
        pm => pm.manager.limitedUser.id === user.id
      );

      // Return true if user has ADMIN role
      return currentUserManagement?.role === PropertyManagementRole.ADMIN;
    },
    enabled: !!getAllPropertyManagersQuery.data && !!user?.id,
    // Default to false when loading or no data
    initialData: false,
  });
};
